<template>
  <div>
    <breadcrumbs :back="back" :home="name"/>

    <purtrak-table name="excisetransactions" objectType="transactions" :defaultColumns="defaultColumns" :headers="headers" ref="table" show-select
                   :listEndPoint="getListData" fields="" totalField="" v-model="selected"
                   :listFilters="listFilters" :sortBy.sync="sortBy"
                   @dblclick="transaction => viewTransaction(transaction)"
                   :title="name"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[filters.from?dateDisplay:'',filters.siteId!=null?siteName:'',filters.activityType!=''?activityTypes.find(a=>a.value==filters.activityType).text:'',filters.excise!='All'?exciseTypes.find(e=>e.value==filters.excise).text:'']}"
                   :download-endpoint="exportListData">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.siteId=null;filters.activityType='';filters.excise='All';filters.from=null;filters.to=null">
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item v-if="sites.length>1">
            <v-autocomplete label="Site" dense outlined :items="[{id:null,name:'All'},{divider:true},...sites]" v-model="filters.siteId" item-text="name" item-value="id"/>
          </v-list-item>
          <v-list-item v-if="activityTypes">
            <v-autocomplete label="Activity" dense outlined :items="activityTypes" v-model="filters.activityType"/>
          </v-list-item>
          <v-list-item v-if="exciseTypes">
            <v-autocomplete label="Excise" dense outlined class="text-body-2" :items="exciseTypes" v-model="filters.excise"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
          <v-chip v-if="sites.length>1" v-show="filters.siteId!=null" close small class="ml-1" @click:close="filters.siteId=null">{{siteName}}</v-chip>
          <v-chip v-if="activityTypes" v-show="filters.activityType!=''" close small class="ml-1" @click:close="filters.activityType=''">{{activityTypes.find(a=>a.value==filters.activityType).text}}</v-chip>
          <v-chip v-if="exciseTypes" v-show="filters.excise!='All'" close small class="ml-1 text-body-2" @click:close="filters.excise='All'">{{exciseTypes.find(e=>e.value==filters.excise).text}}</v-chip>
        </template>
      </template>

      <template v-slot:footer v-if="selected.length">
        <v-icon style="position: absolute" class="mt-3 ml-3">mdi-arrow-up-left</v-icon>
        <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" @click="deleteMultiple=true;showDelete=true">Batch delete</v-btn>
      </template>
      <template v-slot:item.date="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.description="{item,printing}">
        {{item.description}}
        <div v-if="!printing" class="text-caption">{{item.comments}}</div>
      </template>
      <template v-slot:item.alcoholName="{item,printing}">
        {{item.alcoholName}}
        <template v-if="!printing && item.alcoholType!=='Spirit'">
          <div v-if="item.alcoholType==='NonExcise'" class="text-caption">Non-excise</div>
          <div v-else class="text-caption">Wine</div>
        </template>
      </template>
      <template v-slot:item.volume="{item,printing}">
        <template v-if="printing">
          {{item.volume | number(3)}} {{item.alcoholType==='Spirit'?'LAA':'litres'}}
        </template>
        <span v-else :class="{'red--text':item.volume<0}">
          {{item.volume | number(3)}} {{item.alcoholType==='Spirit'?'LAA':'litres'}}
        </span>
      </template>
      <template v-slot:item.volumeBalance="{item}">
        {{item.volumeBalance | number(3)}} {{item.alcoholType==='Spirit'?'LAA':'litres'}}
      </template>
      <template v-slot:item.litresBalance="{value}">
        {{value | number(3)}}
      </template>
      <template v-slot:item.kgBalance="{value}">
        {{value | number(3)}}
      </template>
      <template v-slot:item.valueBalance="{value}">
        {{value | currency}}
      </template>
      <template v-slot:item.litres="{value,printing}">
        <template v-if="printing">{{value | number(3)}}</template>
        <span v-else :class="{'red--text':value<0}">{{value | number(3)}}</span>
      </template>
      <template v-slot:item.kg="{value,printing}">
        <template v-if="printing">{{value | number(3)}}</template>
        <span v-else :class="{'red--text':value<0}">{{value | number(3)}}</span>
      </template>
      <template v-slot:item.strength="{value}">
        {{value | number(2)}}%
      </template>
      <template v-slot:item.value="{value,printing}">
        <template v-if="printing">{{value | currency}}</template>
        <span v-else :class="{'red--text':value<0}">{{value | currency}}</span>
      </template>
      <template v-slot:item.lot="{item,value,printing}">
        <template v-if="printing">{{value}}</template>
        <v-hover v-else-if="item.lot" v-slot="{hover}">
          <a @click.stop="$router.push({name:'ReportsView',params:{back:reportsBack},query:{to:'reports/inventory/ReportsLot',id:item.refId,lot:item.lot,forward:1}})"
            :class="{'text-decoration-underline':hover}">{{item.lot}}</a>
        </v-hover>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Transaction operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="viewTransaction(item)"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'ReportsView',params:{back:reportsBack},query:{to:'reports/inventory/ReportsLot',id:item.refId,lot:item.lot,forward:0}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.refId}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item @click="transaction=item;deleteMultiple=false;showDelete=true"><v-list-item-title>Delete transaction</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:body.append="{headers,printing}" v-if="!$vuetify.breakpoint.mobile">
        <tr :class="darkMode ? 'total-row-dark' : 'total-row'">
          <template v-for="header of headers">
            <td class="text-right" v-if="header.value==='volume'">
              {{totals.totalVolume | number(3)}}
            </td>
            <td class="text-right" v-else-if="header.value==='litres'">
              {{totals.totalLitres | number(3)}}
            </td>
            <td class="text-right" v-else-if="header.value==='value' && values">
              {{totals.totalValue | currency}}
            </td>
            <td class="text-right" v-else-if="header.value==='kg'">
              {{totals.totalKg | number(3)}}
            </td>
            <td v-else-if="!printing || header.print === undefined || header.print"/>
          </template>
        </tr>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="deleteMultiple?'ALL selected transactions':'this transaction'" @delete="performDelete(transaction.refId, 'refId')"/>
  </div>
</template>

<script>
import performDelete from '@/mixins/performDelete'
import viewTransaction from '@/mixins/viewTransaction'

export default {
  name: 'ExciseTransactions',
  mixins: [viewTransaction,performDelete],
  props: {
    listObject: {type:String, required:true},
    objectId: {type: String, required:true},
    activityTypes: {type:Array, required:false},
    exciseTypes: {type:Array,required:false},
    contents: {type:Boolean,required:false,default:false},
    vessel: {type:Boolean,required:false,default:true},
    back: {type:Array,required:false}
  },
  data() {
    return {
      name: '',
      filters: {
        from: null,
        to: null,
        activityType: '',
        excise: 'All',
        siteId: null
      },
      dateDisplay: '',
      sortBy: '',
      transaction: {},
      showDelete: false,
      deleteMultiple: false,
      totals: {totalVolume:0, totalLitres:0, totalValue:0, totalKg:0},
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'vesselName', visible:true},
                       { value: 'alcoholName', visible:true},
                       { value: 'description', visible:true},
                       { value: 'comments', visible:false},
                       { value: 'volume', visible:true},
                       { value: 'volumeBalance', visible:true},
                       { value: 'litres', visible:false},
                       { value: 'litresBalance', visible:false},
                       { value: 'kg', visible:false},
                       { value: 'kgBalance', visible:false},
                       { value: 'strength', visible:false},
                       { value: 'lot', visible:false},
                       { value: 'value', visible:false},
                       { value: 'valueBalance', visible:false}],
      headers: [{ text: 'DATE', value: 'date', width:'15%',sortable:true},
                { text: 'SOURCE', value: 'vesselName', width:'20%',sortable:false, omit:() => !this.vessel},
                { text: 'CONTENTS', value: 'alcoholName', width:'20%',sortable:false, omit:() => this.vessel},
                { text: 'ACTIVITY', value: 'description', width:'25%',sortable:false},
                { text: 'COMMENTS', value: 'comments', width:'25%',sortable:false},
                { text: 'LOT', value: 'lot', width:'10%',sortable:true},
                { text: 'VOLUME', value: 'volume', width:'15%',sortable:true,align:'right'},
                { text: 'VOLUME BAL', value: 'volumeBalance', width:'15%',sortable:false,align:'right',
                  omit:() => !this.showBalances},
                { text: 'LITRES', value: 'litres', width:'15%',sortable:true,align:'right'},
                { text: 'LITRES BAL', value: 'litresBalance', width:'15%',sortable:false,align:'right',
                  omit:() => !this.showBalances},
                { text: 'KG', value: 'kg', width:'15%',sortable:true,align:'right'},
                { text: 'KG BAL', value: 'kgBalance', width:'15%',sortable:false,align:'right',
                  omit:() => !this.showBalances},
                { text: 'STRENGTH', value: 'strength', width:'15%',sortable:true,align:'right'},
                { text: 'VALUE', value: 'value', width:'15%',sortable:true,align:'right', omit:() => !this.values},
                { text: 'VALUE BAL', value: 'valueBalance', width:'15%',sortable:true,align:'right',
                  omit:() => !this.values || !this.showBalances}]
    }
  },
  computed: {
    showBalances() {
      return this.filters.activityType === '' && this.filters.excise === 'All' && this.siteId == null &&
             (this.sortBy === 'date' || this.sortBy === '');
    },
    reportsBack() {
      return [...this.back, {text:this.name,to:this.$route}];
    },
    company() {
      return this.$store.getters.company;
    },
    values() {
      return this.company.permissions.includes('values');
    },
    readOnly() {
      return !this.company.permissions.includes('production.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    sites() {
      return this.$store.getters.sites(false, {B266:true,B263:true});
    },
    siteName() {
      return this.sites.find(site => site.id === this.filters.siteId)?.name;
    },
    listFilters() {
      const filters = [];
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      if (this.filters.siteId)
        filters.push({field:'siteId', comparator:'eq', value:this.filters.siteId});
      if (this.filters.activityType !== '')
        filters.push({field:'refType', comparator:'eq', value:this.filters.activityType});
      if (this.filters.excise !== 'All')
        filters.push({field:'excise', comparator:'eq', value:this.filters.excise});
      return filters;
    }
  },
  methods: {
    async getListData(after, cursor, pageSize, filters, parameters, options) {
      const results = await this.$apiCall(`query ExciseTransactions2($id:ID!, $after: String, $first:Int, $before: String, $last: Int, $filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                             ${this.listObject}(id:$id) {
                                                name
                                                transactions2(first:$first, after:$after, last:$last, before:$before, filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters) {
                                                  totalCount
                                                  totalVolume, totalLitres, totalValue, totalKg
                                                  pageInfo {
                                                    hasPreviousPage
                                                    hasNextPage
                                                    startCursor
                                                    endCursor
                                                  }
                                                  edges {
                                                    cursor
                                                    node {
                                                      id,date,lot,refType,excise,refId,description,comments,volume,litres,kg,
                                                      strength,value,alcoholType,alcoholName,vesselName,vesselId,vesselType
                                                      volumeBalance,litresBalance,valueBalance,kgBalance
                                                    }
                                                  }
                                                }
                                              }
                                            }`,
                                           {id:this.objectId,
                                            after:after?cursor:null, first:after?pageSize:null,
                                            before:!after?cursor:null, last:!after?pageSize:null,
                                            filters, parameters,
                                            sortKey:options.sortBy[0], reverse:options.sortDesc[0]});

      const obj = results.data[this.listObject];
      this.name = `${obj.name}: Transactions`;
      const transactions = obj.transactions2;
      Object.assign(this.totals, {totalVolume:transactions.totalVolume, totalLitres:transactions.totalLitres, totalValue:transactions.totalValue, totalKg:transactions.totalKg});
      return transactions;
    },

    async exportListData(filters, parameters, options) {
      const results = await this.$apiCall(`query ExciseTransactions2($id:ID!, $filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                              ${this.listObject}(id:$id) {
                                                transactionsExportCSV(filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters)
                                              }
                                            }`,
                                          {id:this.objectId,
                                          filters, parameters,
                                           sortKey:options.sortBy[0], reverse:options.sortDesc[0]});
      if (!results.error)
        return results.data[this.listObject]['transactionsExportCSV'];
    }
  }
}
</script>